import React from 'react';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';

import judgeTaaka from 'assets/judge-taaka.png';
import judgeCarl from 'assets/judge-carl.png';
import judgeGima from 'assets/judge-gima.png';
import judgeHibb from 'assets/judge-hibb.png';
import judgeKennedy from 'assets/judge-kennedy.png';
import judgeMamadou from 'assets/judge-mamadou.png';
import judgeRakesh from 'assets/judge-rakesh.png';
import judgeVuyiswa from 'assets/judge-vuyiswa.png';
import PageTitle from 'shared/PageTitle';
import Text from 'ui/Text';

const Judges = () => {
  const judges = [{
    name: 'Taaka Awori',
    title: 'Managing Director',
    company: 'Busara Africa',
    picture: judgeTaaka
  }, {
    name: 'Mamadou Biteye',
    title: 'Managing Director, Africa Regional Office',
    company: 'The Rockefeller Foundation',
    picture: judgeMamadou
  }, {
    name: 'Vuyiswa Sidzumo',
    title: 'Program Officer - Southern Africa',
    company: 'The Ford Foundation',
    picture: judgeVuyiswa
  }, {
    name: 'Gima H. Forje',
    title: "Grants and Partnership Officer",
    company: 'TY Danjuma Foundation',
    picture: judgeGima
  },  {
    name: 'Kennedy Kirui',
    title: "Director",
    company: 'iHub Consulting',
    picture: judgeKennedy
  },  {
    name: 'Carl Manlan',
    title: "COO",
    company: 'Ecobank Foundation',
    picture: judgeCarl
  },  {
    name: 'C.R. Hibb',
    title: "Principal",
    company: 'C.R. Hibbs LLC',
    picture: judgeHibb
  },  {
    name: 'Rakesh Rajani',
    title: "Vice-President for Program",
    company: 'Co-Impact',
    picture: judgeRakesh
  }];

  return (
    <div id="judges">
      <PageTitle title="Judges" />
      <div>
        <div className="inner-content about-explainer bg-light-orange">
          <Text type="heading-semi-bold" modifiers="text-center title heavy">
            <FormattedMessage id="Judges.MeetJudges" defaultMessage="Meet the Judges" />
            <span className="fake-border fake-border__underline center-block bg-pure-white" />
          </Text>
          <div className="row no-margin">
            {
              judges.map((item, i) => (
                <div key={i} className="col-sm-12 col-md-4 col-lg-4 judge-container text-center">
                  <img src={get(item, 'picture')} className="profile-pic" alt={get(item, 'name')}/>
                  <Text modifiers="text-center pure-white bold profile-name">{get(item, 'name')}</Text>
                  <Text type="small" modifiers="text-center pure-white profile-title"><em>{get(item, 'title')}</em></Text>
                  <Text type="small-bold" modifiers="text-center primary-blue">{get(item, 'company')}</Text>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Judges;



// WEBPACK FOOTER //
// ./src/components/HomePage/Judges.js